/**
 * @desc 报表管理 线下销售订单
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.customerOrderStatementManagement.exporting.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/customerOrderStatementManagement/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
